<template>
    <div class="content">
        <div class="head">
            <div>
                <p class="title">作业详情</p>
                <p @click="back()"
                   class="back"></p>
                <p class="preview"
                   @click="preview">作业预览</p>
            </div>
        </div>

        <div class="time_box">
            <p class="jzTime">截止时间：{{ endDate }}</p>
            <p class="endTime"
               v-if="flagBoon">已截止</p>
        </div>
        <div class="tabs_tit">
            <div class="notab">
                完成情况
            </div>
        </div>
        <template v-if="loading">
            <div class="left">
                <div class="left_box">
                    <div class="box_bg1">
                        <div>
                            <p>{{finish}}人</p>
                            <p>已完成</p>
                        </div>
                        <div>
                            <p>{{unfinish}}人</p>
                            <p>未完成</p>
                            <p @click="cuicu">催促</p>
                        </div>
                    </div>
                </div>
                <div class="list"
                     :class="test_type==8?'pb96':''">
                    <div class="list_box">
                        <div class="list_title">
                            <p>学生情况</p>
                        </div>
                    </div>
                    <div class="lists">
                        <div>
                            <p class="name">姓名</p>
                            <p :class="['score',{'sf':test_type==1||test_type==8}]">状态</p>
                            <p :class="['upTime',{'sf':test_type==1||test_type==8}]">{{ test_type == 1|| test_type == 8 ? "" : "完成时间"}}</p>
                        </div>
                    </div>
                    <div class="lists1">
                        <div class="lists_box"
                             v-show="finishlist.length"
                             v-for="(i,index) in finishlist" :key="index">
                            <div class="lists1_result">
                                <p><i>{{i.real_name}}</i><i class="model"
                                       v-if="i.is_excellent==1"></i></p>
                                <p :class="{'sf':test_type==1||test_type==8}">{{ i.status != 0 ? "已完成" : "未完成" }}</p>
                                <p :class="['no',{'sf':test_type==1||test_type==8}]">
                                    <template v-if="i.status != 0">
                                        <button class="picPreview"
                                                @click="previewImg(i.user_id)"
                                                v-if="test_type==1">查看</button>
                                        <span v-if="test_type!=1&&test_type!=8">{{i.test_date}}</span>

                                        <button class="picPreview"
                                                @click="previewImg2(i)"
                                                v-if="test_type==8">查看</button>
                                    </template>
                                    <template v-else>--</template>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="share_sf_task_result"
                 v-if="test_type==8"
                 @click="shareSfTaskResult">
                分享书法作品
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <div id="layui-m-layer"
             class="layui-m-layer layui-m-layer0"
             v-if='urge'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <div class="title_container">
                            <span @click="send_qun"
                                  :class="{'title_on':send_Type=='qun'}"
                                  class="lay_title lay_title1">发到家长群</span>
                            <span @click="send_msg"
                                  :class="{'title_on':send_Type=='msg'}"
                                  class="lay_title lay_title2"
                                  v-if="platform_id=='410000'">发送短信<span class="title_tip">（仅发送开通用户）</span></span>
                        </div>
                        <textarea class="textar"
                                  v-bind:maxlength="200"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'
                                  v-if="send_Type=='qun'">发到家长群里</span>
                            <span @click='release2'
                                  v-if="send_Type=='msg'">发送短信</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width:0;height:0">
            <img :src="item"
                 v-for="(item,index) in finishId" :key="index"
                 alt="">
        </div>
        <imgPreview :data="imgList" v-if="showLayer" :options="options" @close="handleClose"></imgPreview>
        <div class="good-task"
                id="good-task"
             @click="setGoodTask"
             v-show="showGoodTask">
            <img :src="is_excellent?require('./img/excellentCancel.png'):require('./img/excellentSet.png')"
                 alt=""
                 class="pic">
            <p>{{is_excellent?'取消优秀作品':'设为优秀作品'}}</p>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import imgPreview from 'COMPONENTS/imgPreview/preview.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import headers from 'COMPONENTS/base/header.vue'
import $ from 'jquery'
export default {
    components: {
        headers,
        loadingS,
        imgPreview
    },
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            send_Type: 'qun',
            sid: this.$route.query.sid,
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            task_name: this.$route.query.task_name,
            test_type: this.$route.query.test_type,
            begin_date: this.$route.query.begin_date,
            class_name: this.$route.query.class_name,
            taskList: [],
            finishlist: [],//所有学生列表
            finish: null,//完成学生
            unfinish: null,//未完成
            flagBoon: false,//截止时间
            endDate: null,
            loading: false,
            urge: false,
            information1: '你的作业完成了吗？不可以对自己降低要求哟！因为你能做到更好！客户端点此m.tbkt.cn 下载安装。咨询电话：12556185',
            informationObj: {},
            tbkt_Token: localStorage.getItem("Tbkt-Token"),
            city_id: localStorage.getItem('city_id'),
            platform_id: localStorage.getItem('platform_id'),
            isSend: true,//防止连点
            type: 1,//  type 1 催促未做完 2 催促个性化学习 3 催促错题订正
            is_edit: 0,
            sms_id: 0,
            picData: [],
            finishId: [],
            showGoodTask: false,//展示设置优秀作品按钮
            is_excellent: false,//是否是优秀作品
            activeUserId: null,
            showLayer:false,
            imgList:[],
            options:{
                closeEl:false,
                zoomEl:false,
                arrowEl:false,
                preloaderEl:false,
                fullscreenEl:false,
                bgOpacity: 1,
                showHideOpacity: true,
                errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                tapToClose: true, // 点击上层图层关闭预览
            },
            copyVal:'',
        }
    },

    created () {
        this.informationObj = {
            1: [
                `（${this.getSmsdate(this.begin_date)}）${this.sid == 11 || this.sid == 14 ? "爱尚书法" : this.sid == 12 ? "爱尚编程" : "爱尚模型"}的${this.task_name}作业以下孩子未完成，请尽快督促孩子完成。`,
                '',//接口获取
            ]
        }
        this.loading = true;

        if (this.test_type == 8) {
            this.getSfShowDetail()
        } else {
            this.getlist();
        }
    },
    mounted () {
        

    },
    methods: {
        send_qun () {
            this.send_Type = 'qun'
            this.information1 = this.informationObj[this.type][0];
        },
        send_msg () {
            this.send_Type = 'msg';
            this.information1 = this.informationObj[this.type][1];
        },
        back () {
            this.$router.go(-1)
        },
        cuicu () {
            this.send_Type = 'qun'
            if (Number(this.unfinish)) {
                this.$store.dispatch('urge_content', {
                    'sid': this.sid,
                    'task_type': this.task_name,
                    'begin_date': Number(this.begin_date),
                    'type': this.type
                }).then((res) => {
                    let _res = res.data.data;
                    this.sms_id = _res.sms_id;
                    this.informationObj[this.type][1] = _res.content;
                    this.information1 = this.informationObj[this.type][0];
                    this.is_edit = 0;
                    this.urge = !this.urge;
                })
            } else {
                layer.tips('所有学生都已完成')
            }
        },
        info1 () {
            var textVal = this.information1.length;
            if (this.send_Type == 'msg') {
                this.is_edit = 1;
            }
            if (this.information1.length >= 200) {
                layer.tips('已经超过200字了')
            }
        },
        cancel () {
            this.is_edit = 0;
            this.urge = false;
        },
        release2 () {//发送短信
            if (!this.isSend) {
                return false;
            }
            this.isSend = false;
            let this_ = this
            let stu_user_id = []
            this.finishlist.forEach(item => {
                if (item.status == 0) {
                    stu_user_id.push(item.user_id)
                }
            })
            this.$http.post(API_URL_TASK_API + '/public/task/urge', {
                message_id: this_.taskId,
                unit_class_id: this_.classId,
                sid: this_.sid,
                stu_user_id: stu_user_id.join(','),
                type: this.type,
                content: this_.information1,
                task_type: this.task_name,
                begin_date: Number(this.begin_date),
                is_edit: this.is_edit,
                sms_id: this.sms_id,
                place_id: 25,//配置平台发送短信配置参数
            }).then(res => {
                this.isSend = true;
                if (res.data.response == 'ok') {
                    this_.urge = false;
                    layer.tips("发送成功！");
                } else {
                    layer.tips("发送失败！");
                }
            })
            this.isSend = true;
        },
        release () {
            let that=this
            // if(!this.isSend){
            //     return false;
            // }
            // this.isSend = false;
            this.information1 = this.information1.replace(/(^\s*)|(\s*$)/g, "");
            this.information1 = this.information1.replace(/,/g, '，');
            if (this.information1.length > 200) {
                layer.tips('已经超过200字了');
                return false
            } else if (this.information1 == 0) {
                layer.tips('内容为空');
                return false
            }

            this.$http.post(API_URL_TASK_API + '/public/task/tea/share/in', {
                message_id: this.taskId,
                unit_class_id: this.classId,
                content: this.information1,
                type: 0
            }).then(res => {

                // this.isSend = true;
                if (res.data.response == 'ok') {

                    this.cancel();
                    let id = res.data.data.id;
                    let content = res.data.data.content;
                    let url = VUE_URL_HD + `/#/share/examine_task?sid=${this.sid}&type=0&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    let title = `同步课堂`;
                    if (this.city_id == "411600") {
                        title = "随堂练";
                    }
                    let place = "教师检查作业催促发送到群里";
                    if (this.inApp) {
                        this.appFunction("ys_share", `${title},${content},${url},${this.sid},${this.classId},0,0,${place}`);
                    } else {
                        setTimeout(() => {
                            let coptText = `（${this.getSmsdate(this.begin_date)}）${this.sid == 11||this.sid == 14 ? "爱尚书法" : this.sid == 12 ? "爱尚编程" : "爱尚模型"}的${this.task_name}作业以下孩子未完成，请尽快督促孩子完成。链接：${url}`;
                            this.copyVal=coptText
                            layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                                layer.close(index)
                                that.copyText(that.copyVal);
                            }, '分享链接复制成功')
                        }, 300)
                    }
                    //console.log(url)
                }
            })
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        preview () {//作业预览
            if (this.test_type == 1) {
                this.$router.push("/qualityStation/preview/words/" + this.taskId);
            } else if (this.test_type == 8) {
                //如果是书法作品展示类型的作业
                this.$router.push("/qualityStation/preview/task_require/" + this.taskId);
            } else {
                this.$router.push("/qualityStation/preview/video/" + this.taskId);
            }
        },
        getlist () {
            this.$http.get(`${API_URL_TASK_API}/szyz/check/task/detail?message_id=${this.taskId}&unit_class_id=${this.classId}`).then(res => {
                let res1 = res.data;
                if (res1.response == 'ok') {
                    this.loading = true;
                    let data = res.data.data;
                    this.finishlist = data.students;
                    this.finish = data.finish_num;
                    this.unfinish = data.unfinished_num;
                    this.endDate = data.end_date;
                    if (res1.data.is_end == 1) {
                        this.flagBoon = true;
                    } else {
                        this.flagBoon = false;
                    }
                    this.finishlist.forEach(e => {
                        if (e.status != 0) {
                            this.$http.post(API_URL_TASK_API + '/szyz/check/task/sync_calligraph_detail', {
                                message_id: this.taskId,
                                user_id: e.user_id
                            }).then(res => {
                                res.data.data.forEach(e => {
                                    this.finishId.push(e)
                                })
                            })
                        }

                    })

                }
            })
        },
        getSfShowDetail () {
            this.$http.get(`${API_URL_TASK_API}/szyz/check/task/sf_works_show/detail?message_id=${this.taskId}&unit_class_id=${this.classId}`).then(res => {
                let res1 = res.data;
                if (res1.response == 'ok') {
                    this.loading = true;
                    let data = res.data.data;
                    this.finishlist = data.students;
                    this.finish = data.finish_num;
                    this.unfinish = data.unfinished_num;
                    this.endDate = data.end_date;
                    if (res1.data.is_end == 1) {
                        this.flagBoon = true;
                    } else {
                        this.flagBoon = false;
                    }
                    this.finishlist.forEach(e => {
                        if (e.status != 0) {
                            let imgArr = []
                            imgArr = e.answer
                            imgArr.forEach(j => {
                                let url = FILE_VIEW_URLROOT + '/' + j
                                this.finishId.push(url)
                            })

                        }

                    })
                }
            })
        },
        previewImg (id) {
            this.$http.post(API_URL_TASK_API + '/szyz/check/task/sync_calligraph_detail', {
                message_id: this.taskId,
                user_id: id
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.picData = res.data

                    this.$nextTick(() => {

                        this.$imagePreview({
                            images: res.data,
                            index: 0,
                            defaultOpt: {
                                bgOpacity: 1,
                                showHideOpacity: true,
                                errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                                tapToClose: true, // 点击上层图层关闭预览
                            }
                        });
                    })
                }
            })
        },
        previewImg2 (item) {
             this.activeUserId = item.user_id
            if (item.is_excellent) {
                this.is_excellent = true
            } else {
                this.is_excellent = false
            }
            let urls = []
            item.answer.forEach(e => {
                urls.push(FILE_VIEW_URLROOT + '/' + e)
            })
            this.imgList=urls
            this.showLayer=true
            //加个定时器，避免图片出现的快
            setTimeout(() => {
                this.showGoodTask = true
            }, 300)
         
          
        },
        handleClose(){
            this.showGoodTask = false
            this.showLayer=false
        },
        // 设为优秀作品
        setGoodTask () {
            let url = API_URL_TASK_API + '/szyz/check/task/sf_works_show/excellent'
            let params = {
                message_id: this.taskId,
                user_id: this.activeUserId,
                is_excellent: this.is_excellent ? 0 : 1
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response == 'ok') {
                    this.is_excellent = !this.is_excellent
                    this.getSfShowDetail()
                }
            })
        },
        //书法作品展示分享
        shareSfTaskResult () {
            let title = `${this.class_name}书法作品展示`;
            let content = `点击查看书法作品展示`;
            let url = VUE_URL_HD+ `/#/sfzp/${this.taskId}/${this.classId}`;
            if (this.inApp) {
                this.appFunction("ys_share", `${title},${content},${url}`);
            } else {
                let coptText = `家长您好，请点击链接${url}，查看孩子和同学们的书法作品，一起看看谁获得了优秀书法作品的评价吧！`;
                this.copyText(coptText);
                layer.alert(`将链接粘贴并发送到对应的班级群，家长点击链接即可。`, 'tea', function (index) {
                    layer.close(index)
                }, '分享链接复制成功')
            }
        },
      
    },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.content {
    position: relative;
}

.title_container {
    width: 93.4%;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 0.4rem;
}

.lay_title {
    color: #000000;
    text-align: center;
    padding: 0.25rem 0;
    float: left;
    font-size: 0.7rem;
    border-bottom: none;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    box-sizing: border-box;
}

.title_on {
    background-color: #f0f0f0;
}

.title_tip {
    color: red;
    font-size: 0.6rem;
}

.lay_title1 {
    width: 30%;
}

.lay_title2 {
    width: 70%;
}

.content {
    width: 100vw;
    background: #f5f9ff;
    overflow-x: hidden;
    min-height: 100%;
}

.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;
        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }
        .back {
            display: block;
            width: 76px / $ppr;
            height: 96px / $ppr;
            background: url(./img/choose_back.png) no-repeat;
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
        }
        .preview {
            position: absolute;
            top: 0;
            height: 2.4rem;
            line-height: 2.4rem;
            right: 0.6rem;
            z-index: 10;
            font-size: .75rem;
            color: #fff;
        }
    }
}

.time_box {
    width: 100%;
    height: 96px / $ppr;
    margin-top: 96px / $ppr;
    background: #5e89ef;
    .jzTime {
        padding-left: 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        color: #fff;
        font-size: 30px / $ppr;
        float: left;
    }
    .endTime {
        float: right;
        font-size: 30px / $ppr;
        color: #dde7fd;
        margin-right: 24px / $ppr;
        line-height: 96px / $ppr;
    }
}

.tabs_tit-top {
    margin-top: 100px / $ppr;
    // text-align:center;
}
.notab {
    width: 100%;
    height: 96px / $ppr;
    font-weight: bold;
    line-height: 96px / $ppr;
    // text-align: left;
    font-size: 30px / $ppr;
    margin-bottom: 24px / $ppr;
    // padding-left: 24px/$ppr;
    background-color: #fff;
    position: relative;
    z-index: 2;
    text-align: center;
}

.check {
    border-bottom: 4px solid #5e89ef;
    color: #5e89ef;
}

.nocheck {
    color: #333;
}

.noresources {
    width: 100%;
    height: 300px / $ppr;
    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

.left {
    width: 100%;
    height: auto;
    .left_box {
        width: 100%;
        height: 239px / $ppr;
        background: #fff;
        padding-top: 23px / $ppr;
        .box_bg1 {
            width: 672px / $ppr;
            height: 238px / $ppr;
            background: url(./img/icon_bg1.png) no-repeat;
            background-size: 100%;
            margin: 0 auto;
            div {
                float: left;
                width: 330px / $ppr;
                height: 238px / $ppr;
                p {
                    width: 100%;
                }
                p:nth-child(1) {
                    height: 44px / $ppr;
                    line-height: 44px / $ppr;
                    text-align: center;
                    margin-top: 44px / $ppr;
                    color: #ff6600;
                    font-size: 48px / $ppr;
                    font-weight: bold;
                }
                p:nth-child(2) {
                    height: 23px / $ppr;
                    line-height: 23px / $ppr;
                    text-align: center;
                    margin-top: 15px / $ppr;
                    color: #999;
                    font-size: 24px / $ppr;
                }
                p:nth-child(3) {
                    text-align: center;
                    margin-top: 34px / $ppr;
                    color: #5e89ef;
                    font-size: 24px / $ppr;
                }
            }
            div:nth-child(1) {
                margin-right: 12px / $ppr;
            }
        }
    }
}

.list {
    width: 100%;
    height: auto;
    background: #fff;
    margin-top: 25px / $ppr;
    .list_box {
        width: 100%;
        border-bottom: 1px / $ppr solid #e2e5ec;
        .list_title {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            //font-weight:600;
            p:nth-child(1) {
                float: left;
                line-height: 96px / $ppr;
                font-size: 36px / $ppr;
                color: #333;
            }
            p:nth-child(2) {
                float: right;
                line-height: 96px / $ppr;
                font-size: 30px / $ppr;
                color: #5e89ef;
            }
        }
    }
    .lists {
        width: 100%;
        height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e2e5ec;
        div {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #333;
            }
            .name {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
            }
            .score {
                width: 120px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 84px / $ppr;
                &.sf {
                    width: 274px / $ppr;
                }
            }
            .upTime {
                width: 260px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                float: right;
                &.sf {
                    width: 132px / $ppr;
                }
            }
        }
    }
    .lists1 {
        .lists_box {
            width: 100%;
            border-bottom: 1px / $ppr solid #e2e5ec;
        }
        .lists1_result {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #999;
                font-size: 30px / $ppr;
            }
            p:nth-child(1) {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
                position: relative;
            }
            p:nth-child(2) {
                width: 120px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                i {
                    color: #ff8042;
                }
                &.sf {
                    width: 274px / $ppr;
                }
            }
            p:nth-child(3) {
                width: 290px / $ppr;
                line-height: 96px / $ppr;
                float: right;
                &.sf {
                    width: 132px / $ppr;
                }
            }
            .no {
                text-align: center;
                position: relative;
            }
            .picPreview {
                width: 108px / $ppr;
                height: 48px / $ppr;
                border: none;
                background-color: #5e89ef;
                color: #fff;
                font-size: 24px / $ppr;
                border-radius: 24px / $ppr;
            }
            .model {
                display: inline-block;
                width: 18px;
                height: 18px;
                background: url("./img/icon-model.png") no-repeat center;
                background-size: cover;
                vertical-align: middle;
                margin-left: 5px / $ppr;
            }
        }
    }
    .lists_box:last-child {
        border: 0;
    }
}

.layui-m-layerchild {
    text-align: center;
}

.textar {
    margin: auto 0;
    width: 86%;
    min-height: 200px / $ppr;
    margin: 30px / $ppr 0;
    margin-top: 0;
    background: #f0f0f0;
    border: none;
    padding: 20px / $ppr;
    border-bottom-left-radius: 10px / $ppr;
    border-bottom-right-radius: 10px / $ppr;
    font-size: 30px / $ppr;
}

.layui-m-layerbtn {
    border-top: 1px / $ppr solid #f0f0f0 !important;
    span {
        width: 50%;
        background: #fff;
    }
    span:nth-child(1) {
        border-right: 1px / $ppr solid #f0f0f0;
    }
    span:nth-child(2) {
        color: #5e89ef;
        border-right: 1px / $ppr solid #f0f0f0;
    }
}
.picData {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    padding: 110px / $ppr 10px / $ppr 10px / $ppr 10px / $ppr;
    box-sizing: border-box;
    z-index: 9;

    img {
        display: block;
        width: 33.33333%;
        float: left;
    }
}
.viewPicData {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 1px;
    height: 1px;
    top: 60px / $ppr;
    left: 12px / $ppr;
    z-index: 99;
    overflow: hidden;
    border-radius: 48px / $ppr;
    img {
        display: none;
    }
}
.share_sf_task_result {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #5e89ef;
    height: 96px / $ppr;
    text-align: center;
    line-height: 96px / $ppr;
    font-size: 28px / $ppr;
    color: #fff;
}
.pb96 {
    padding-bottom: 96px / $ppr;
}
.good-task {
    position: fixed;
    right: 50px / $ppr;
    bottom: 100px / $ppr;
    z-index: 1999;
    text-align: center;
    .pic {
        width: 136px / $ppr;
        height: 136px / $ppr;
        margin-bottom: 10px / $ppr;
    }
    p {
        color: #fff;
        font-size: 24px / $ppr;
    }
}

</style>
